import HomeIcon from '@mui/icons-material/Home';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { MenuItems } from './interfaces';

const menuItemsDriver: MenuItems[] = [
    {
        heading: '',
        items: [
            {
                name: 'Home',
                icon: HomeIcon,
                link: '/driver/dashboard'
            },
            {
                name: 'Events',
                icon: EventAvailableIcon,
                link: '/driver/events'
            },
            {
                name: 'Notifications',
                icon: NotificationsActiveIcon,
                link: '/driver/notifications'
            },

        ]
    }
];

export default menuItemsDriver;
